import { Metamodel } from 'app/model/base/model';
import { FormatWriteSettings } from './format-write-settings';
import { IModel, IAttribute } from 'app/model/base/annotation';

import { AvroDataset } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.avro.formatWrite,
    tags: { datasetModel: Metamodel.modelFor(AvroDataset) }
})
export class AvroFormatWriteSettings extends FormatWriteSettings {
    public static readonly MODEL: IModel;
    public static readonly RECORD_NAME: IAttribute;
    public static readonly RECORD_NAMESPACE: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'RECORD_NAME',
        display: stringResources.ModelName_RecordName
    })
    public recordName?: boolean;

    @Metamodel.attribute({
        templatable: true,
        association: 'RECORD_NAMESPACE',
        display: stringResources.ModelName_RecordNamesapce
    })
    public recordNamespace?: boolean;
}
